import { MappedNotification } from 'common/header/notifications/Notifications.types';
import { getNotificationState } from 'common/header/notifications/hooks/Notification.utils';
import { NotificationIntlMessages } from 'src/components/common/header/translations/useNotificationsIntl';

export const getGlobalIdTitle = (
  notificationViewModel: Partial<MappedNotification>,
  intl: NotificationIntlMessages
): Pick<MappedNotification, 'title' | 'description' | 'iconType'> => {
  const state = getNotificationState(notificationViewModel.status);

  if (state.isError) {
    return {
      title: intl.globalIdFailureTitle,
      description: '',
      iconType: 'FAILURE'
    };
  }
  if (state.isReady) {
    return {
      title: intl.globalIdSuccessTitle,
      description: '',
      iconType: 'SUCCESS'
    };
  }

  return {
    title: intl.globalIdInProgressTitle,
    description: '',
    iconType: 'INFO'
  };
};
